import React from "react";

import { StructuredLocationLabels, formatStructuredLocation } from "utils/location-hierarchy";

interface StructuredLocationProps {
	labels?: StructuredLocationLabels | null;
	// Extra class for spacing tweaks per host table, if ever needed.
	className?: string;
}

/**
 * Secondary "Building › Floor › Room" line shown under a device's free-text location.
 * Renders nothing when no structured level is set, so it's safe to drop into any cell.
 * Styles are global (src/styles/App.scss → components/structured-location).
 */
const StructuredLocation: React.FC<StructuredLocationProps> = ({ labels, className }) => {
	const text = formatStructuredLocation(labels);
	if (!text) return null;
	return <div className={`structured-location${className ? ` ${className}` : ""}`}>{text}</div>;
};

export default StructuredLocation;
